import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { PriceProvider } from './contexts/PriceContext';
import { CartDrawer } from './components/CartDrawer';
import { Layout } from './components/Layout';
import { Home } from './components/pages/site/Home';
import { Booklet } from './components/pages/Booklet';
import { About } from './components/pages/site/About';
import { Services } from './components/pages/site/Services';
import { Shop } from './components/pages/site/Shop';
import { ProductDetail } from './components/pages/site/ProductDetail';
import { Books } from './components/pages/site/Books';
import { Contact } from './components/pages/site/Contact';
import { Training } from './components/pages/site/Training';
import { Login, Signup, ForgotPassword } from './components/pages/site/Auth';
import { Account } from './components/pages/site/Account';
import { Checkout } from './components/pages/site/Checkout';
import { PreOrderConfirmation } from './components/pages/site/PreOrderConfirmation';
import { Privacy } from './components/pages/site/Privacy';
import { Terms } from './components/pages/site/Terms';
import { AdminLayout } from './components/pages/admin/AdminLayout';
import { AdminDashboard } from './components/pages/admin/AdminDashboard';
import { AdminOrderDetail } from './components/pages/admin/AdminOrderDetail';
import { AdminNewsletter } from './components/pages/admin/AdminNewsletter';
export function App() {
  // Lock the browser tab title to the brand name. The preview environment can
  // otherwise inject placeholder titles (e.g. generation request text) into the
  // document title; this overrides it on load.
  useEffect(() => {
    document.title = 'Structured Nutrition';
  }, []);
  return <AuthProvider data-id="element-0">
      <PriceProvider data-id="element-1">
        <CartProvider data-id="element-2">
          <BrowserRouter data-id="element-3">
            <CartDrawer data-id="element-4" />
            <Routes data-id="element-5">
              {/* Site Routes with Layout (Nav + Footer) */}
              <Route element={<Layout data-id="element-7" />} data-id="element-6">
                <Route path="/" element={<Home data-id="element-9" />} data-id="element-8" />
                <Route path="/about" element={<About data-id="element-11" />} data-id="element-10" />
                <Route path="/services" element={<Services data-id="element-13" />} data-id="element-12" />
                <Route path="/shop" element={<Shop data-id="element-15" />} data-id="element-14" />
                <Route path="/shop/:productId" element={<ProductDetail data-id="element-17" />} data-id="element-16" />
                <Route path="/books" element={<Books data-id="element-19" />} data-id="element-18" />
                <Route path="/training" element={<Training data-id="element-21" />} data-id="element-20" />
                <Route path="/contact" element={<Contact data-id="element-23" />} data-id="element-22" />
                <Route path="/login" element={<Login data-id="element-25" />} data-id="element-24" />
                <Route path="/signup" element={<Signup data-id="element-27" />} data-id="element-26" />
                <Route path="/forgot-password" element={<ForgotPassword data-id="element-29" />} data-id="element-28" />
                <Route path="/account" element={<Account data-id="element-31" />} data-id="element-30" />
                <Route path="/checkout" element={<Checkout data-id="element-33" />} data-id="element-32" />
                <Route path="/pre-order-confirmation" element={<PreOrderConfirmation data-id="element-35" />} data-id="element-34" />
                <Route path="/privacy" element={<Privacy data-id="element-37" />} data-id="element-36" />
                <Route path="/terms" element={<Terms data-id="element-39" />} data-id="element-38" />
              </Route>

              {/* Standalone Booklet Route (No Nav/Footer, keeps print layout) */}
              <Route path="/booklet" element={<Booklet data-id="element-41" />} data-id="element-40" />

              {/* Admin Routes (Standalone Layout) */}
              <Route path="/admin" element={<AdminLayout data-id="element-43" />} data-id="element-42">
                <Route index element={<AdminDashboard data-id="element-45" />} data-id="element-44" />
                <Route path="orders" element={<AdminDashboard data-id="element-47" />} data-id="element-46" />
                <Route path="orders/:orderId" element={<AdminOrderDetail data-id="element-49" />} data-id="element-48" />
                <Route path="newsletter" element={<AdminNewsletter data-id="element-51" />} data-id="element-50" />
              </Route>
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </PriceProvider>
    </AuthProvider>;
}